import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider } from "@/lib/i18n";
import UtilityBar from "@/components/UtilityBar";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Pillars from "@/components/Pillars";
import Story from "@/components/Story";
import SignatureDeal from "@/components/SignatureDeal";
import MenuBrowser from "@/components/MenuBrowser";
import Brunch from "@/components/Brunch";
import Order from "@/components/Order";
import PrivateEvents from "@/components/PrivateEvents";
import Press from "@/components/Press";
import Gallery from "@/components/Gallery";
import Reservation from "@/components/Reservation";
import Visit from "@/components/Visit";
import Footer from "@/components/Footer";

function HomePage() {
  return (
    <div className="App relative bg-[#FDFBF7]" data-testid="home-page">
      <UtilityBar />
      <Navbar />
      <Hero />
      <Marquee />
      <Pillars />
      <Story />
      <SignatureDeal />
      <MenuBrowser />
      <Brunch />
      <Order />
      <PrivateEvents />
      <Gallery />
      <Press />
      <Reservation />
      <Visit />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1A1713",
            color: "#FDFBF7",
            border: "1px solid #C98A4B",
            borderRadius: 0,
            fontFamily: "DM Sans, sans-serif",
          },
        }}
      />
    </I18nProvider>
  );
}

export default App;
